import { FetchRequest } from "@rails/request.js"

export function submitForm(form, headers = {}) {
  const request = new FetchRequest(form.method, form.action, {
    body: new FormData(form),
    headers
  })
  return request.perform()
}
